<template>
    <div class="tab-history-wrap section-space--mt_80">
        <div class="row">
            <div class="col-lg-7">
                <div class="tab-history-image">
                    <img src="../assets/img/banners/aeroland-tab-content-image-04.png" alt="" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-5">
                <div class="tab-content-inner">
                    <div class="heading mb-30">Meeting all of your requirements for SEO &amp; branding</div>
                    <ul class="check-list green-check-list section-space--mb_50">
                        <li class="list-item">Receive real-time business analytics </li>
                        <li class="list-item">Cross-browser Compatible Design </li>
                        <li class="list-item">Completely Gutenberg Ready </li>
                        <li class="list-item">Highly Responsive Tools </li>
                    </ul>
                    <div class="tab-button mb-30">
                        <button class="ht-btn ht-btn-md">Learn more </button>
                    </div>
                    <h6 class="sub-heading">What’s next in AeroLand? 
                        <router-link to="/" class="hover-style-link hover-style-link--green">Learn more</router-link>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</template>

